import { styled } from "@mui/material/styles";

const ExperimentLayout = styled("div")`
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fc;
  box-sizing: border-box;
  overflow: auto;
`;

const ExperimentLayoutContent = styled("div")`
  width: 100%;
  padding: 32px 16px;
  overflow: auto;
  min-height: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 32px 30px;
  }

  @media (min-width: 1024px) {
    padding: 50px 60px;
    max-width: 1700px;
    margin: 0 auto;
  }
`;

export { ExperimentLayout, ExperimentLayoutContent };
